import { Button, Container, Stack } from 'react-bootstrap';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faClockRotateLeft } from '@fortawesome/pro-duotone-svg-icons';
import { IconDefinition } from '@fortawesome/fontawesome-svg-core';

import Header from '@components/Header/HeaderNav';
import Footer from '@components/Footer/Footer';
import useAuth from '@hooks/useAuth';
import { BRAND_PRE } from '@constants/constants';

import './SessionExpired.scss';

export default function SessionExpired() {
  const { onLogin } = useAuth();

  return (
    <Stack>
      <Header />
      <div className={`d-flex flex-grow-1 position-relative ${BRAND_PRE}session-expired-container`}>
        <Container fluid='xxl' className='d-flex flex-column py-4 session-expired-content'>
          <div className='session-expired-content-inner text-center d-flex flex-column flex-grow-1 py-5 rounded-2'>
            <Stack gap={4} className='justify-content-center p-3 h-100'>
              <FontAwesomeIcon icon={faClockRotateLeft as IconDefinition} fontSize={64} className='text-primary' />
              <h1 className='mb-0 fs-3 lh-xs'>Session Expired</h1>
              <div className='fs-6'>Your session has timed out. Please log in again to continue.</div>
              <Button onClick={() => onLogin('/requisitions')} className='align-self-center'>
                Log In
              </Button>
            </Stack>
          </div>
        </Container>
      </div>

      <Footer />
    </Stack>
  );
}
